export default __webpack_public_path__ + "static/media/circle_button_mj.5758f892.png";